import {FC} from 'react';
import {InputWithRemove} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/InputWithRemove/InputWithRemove';
import {Section} from '~/OneStepCreateInvitation/routes/OneStepCreatePage/components/DetailsFields/components/Section/Section';

interface FakeInputProps {
  title: string;
  value: string;
  onClick: () => void;
  onRemove: () => void;
  dataQaId: string;
}

export const FakeInput: FC<FakeInputProps> = ({title, value, onClick, onRemove, dataQaId}) => (
  <div>
    <Section title={title}>
      <InputWithRemove
        dataQaId={dataQaId}
        value={value}
        onClick={onClick}
        onRemove={onRemove}
        fullWidth
      />
    </Section>
  </div>
);
